import { render, staticRenderFns } from "./AwardCategoryEdit.vue?vue&type=template&id=309d478a"
import script from "./AwardCategoryEdit.vue?vue&type=script&lang=js"
export * from "./AwardCategoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports